const mall = [
  {
    name: "星巴克",
    id: 0,
    center: [121.507168, 31.240737],
    bounds: [
      [121.507209, 31.240591],
      [121.507168, 31.240737],
      [121.506789, 31.240712],
      [121.506928, 31.240469],
    ],
    car: [
      521,
      186,
      96,
      6,
      26,
      252,
      925,
      976,
      1143,
      1104,
      981,
      863,
      733,
      1032,
      623,
      823,
      834,
      1225,
      1398,
      1325,
      932,
      734,
      682,
      321,
    ],
    customer: [
      92,
      72,
      24,
      14,
      0,
      33,
      57,
      96,
      163,
      153,
      125,
      163,
      243,
      184,
      105,
      163,
      121,
      241,
      263,
      133,
      184,
      163,
      153,
      73,
    ],
  },
  {
    name: "正大百货",
    id: 1,
    center: [121.505534, 31.242951],
    bounds: [
      [121.504842, 31.242589],
      [121.506503, 31.243353],
      [121.507033, 31.242682],
      [121.505246, 31.242018],
    ],
    car: [
      750,
      320,
      83,
      13,
      47,
      627,
      834,
      1242,
      1463,
      1282,
      1136,
      1127,
      941,
      993,
      864,
      934,
      1123,
      1337,
      1574,
      1434,
      1179,
      953,
      833,
      642,
    ],
    customer: [
      524,
      73,
      79,
      68,
      43,
      242,
      517,
      825,
      823,
      817,
      251,
      652,
      664,
      602,
      173,
      434,
      113,
      737,
      852,
      849,
      812,
      564,
      203,
      303,
    ],
  },
  {
    name: "星期五餐厅",
    id: 2,
    center: [121.504534, 31.241951],
    bounds: [
      [121.504534, 31.241951],
      [121.504161, 31.241816],
      [121.504404, 31.241554],
      [121.504615, 31.24165],
    ],
    car: [
      123,
      89,
      14,
      0,
      3,
      132,
      251,
      473,
      896,
      924,
      997,
      734,
      1155,
      1021,
      513,
      423,
      704,
      1078,
      1189,
      1023,
      743,
      521,
      325,
      253,
    ],
    customer: [
      67,
      38,
      13,
      13,
      0,
      76,
      124,
      193,
      238,
      164,
      114,
      210,
      286,
      275,
      98,
      121,
      93,
      295,
      244,
      179,
      146,
      174,
      123,
      121,
    ],
  },
]
var professionData = [
  [
    {
      value: 0,
      name: "男",
    },
    {
      value: 0,
      name: "女",
    },
  ],
  [
    {
      value: 0,
      name: "学生",
    },
    {
      value: 0,
      name: "家庭主妇",
    },
    {
      value: 0,
      name: "自由职业者",
    },
    {
      value: 0,
      name: "公务员",
    },
    {
      value: 0,
      name: "企业管理员",
    },
    {
      value: 0,
      name: "专业技术人员",
    },
    {
      value: 0,
      name: "其它",
    },
    {
      value: 0,
      name: "事业单位职员",
    },
  ],
]
var sum = 0
mall.forEach((d) => {
  d.car.forEach((c) => {
    sum += c
  })
})

var bi = [0.038, 0.139, 0.065, 0.131, 0.176, 0.107, 0.211, 0.124]
var ts = professionData[1]
for (let i = ts.length - 1; i >= 0; i--) {
  ts[i].value = Math.round(sum * bi[i])
}
professionData[0][0] = Math.round(sum * 0.672)
professionData[0][1] = Math.round(sum * 0.328)

// const ONLINE_HTTP = "http://106.15.59.81:8080" //"http://106.15.57.39:9876"
const ONLINE_HTTP = "https://lgraph-api.newayz.com" //"http://106.15.57.39:9876"
const STATIC_URL = "https://api.newayz.com/api/vtiles/v1/static" //"http://139.224.209.175:9998" //"http://139.224.209.175:9997"

//byd_num 前客流
//byd_num：前日 td_num:今日  yd_num: 昨日
// month_total: 月总  day_new_add 月增   day_mean_add 日均增
// day_mean: 月均 max_nums: 日高   日高增： max_new_add
const visitorFlow = {
  0: {
    data: {
      report: { yd_num: 3113, byd_num: 2863 },
      vdata: {
        yd: [164, 38, 33, 153, 316, 278, 917, 728, 362, 301, 347, 226],
        byd: [158, 31, 36, 153, 336, 278, 727, 262, 361, 391, 339, 221],
        series: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
      },
    },
  },
  2: {
    data: {
      report: { yd_num: 3375, byd_num: 3521 },
      vdata: {
        yd: [101, 23, 75, 311, 389, 342, 541, 231, 364, 435, 337, 183],
        byd: [105, 26, 76, 317, 402, 324, 561, 219, 388, 423, 320, 244],
        series: [
          "2:00",
          "4:00",
          "6:00",
          "8:00",
          "10:00",
          "12:00",
          "14:00",
          "16:00",
          "18:00",
          "20:00",
          "22:00",
          "24:00",
        ],
      },
    },
  },
}
// 到访分析
const visitorRecord = {
  0: {
    data: {
      customerType: { one: 37, more: 63 },
      trend: [
        [
          1.66,
          2.98,
          3.12,
          2.48,
          1.96,
          2.9,
          2.97,
          2.95,
          3.06,
          2.99,
          2.59,
          2.06,
          3.04,
          3.21,
          3.1,
          2.98,
          2.92,
          2.0,
          2.92,
          2.87,
          2.53,
          2.47,
          2.97,
          2.2,
          2.71,
          2.66,
          2.49,
          2.59,
          2.63,
          2.91,
          3.02,
        ],
        [
          1.07,
          3.33,
          3.29,
          1.86,
          1.95,
          2.86,
          3.56,
          3.7,
          3.83,
          3.66,
          2.68,
          2.38,
          3.63,
          3.99,
          4.04,
          3.74,
          3.71,
          1.92,
          3.11,
          3.28,
          3.0,
          2.39,
          2.78,
          3.1,
          5.64,
          2.14,
          2.34,
          3.19,
          3.59,
          3.83,
          3.07,
        ],
      ],
    },
  },
  2: {
    data: {
      customerType: { one: 42, more: 58 },
      trend: [
        [
          1.66,
          2.98,
          3.12,
          2.48,
          1.96,
          2.9,
          2.97,
          2.95,
          3.06,
          2.99,
          2.59,
          2.06,
          3.04,
          3.21,
          3.1,
          2.98,
          2.92,
          2.0,
          2.92,
          2.87,
          2.53,
          2.47,
          2.97,
          2.2,
          2.71,
          2.66,
          2.49,
          2.59,
          2.63,
          2.91,
          3.02,
        ],
        [
          1.07,
          3.33,
          3.29,
          1.86,
          1.95,
          2.86,
          3.56,
          3.7,
          3.83,
          3.66,
          2.68,
          2.38,
          3.63,
          3.99,
          4.04,
          3.74,
          3.71,
          1.92,
          3.11,
          3.28,
          3.0,
          2.39,
          2.78,
          3.1,
          5.64,
          2.14,
          2.34,
          3.19,
          3.59,
          3.83,
          3.07,
        ],
      ],
    },
  },
  5002: {
    data: {
      shop_name: "海底捞",
      vnum: { one: 83, two: 48, three: 50, four: 23, more: 47 },
      gender: { female: 55, male: 45, unknown: 249 },
    },
  },
  1027: {
    data: {
      shop_name: "GUCCI",
      vnum: { one: 332, two: 17, three: 3, four: 3, more: 9 },
      gender: { female: 65, male: 35, unknown: 362 },
    },
  },
}
// 基础画像
const userProfile = {
  0: {
    data: {
      gender: { male: 51, female: 49 },
      age: [0.11, 0.23, 0.37, 0.13, 0.1, 0.06].map((r) => {
        return Math.round(visitorFlow[0].data.report.yd_num * r)
      }),
    },
  },
  2: {
    data: {
      gender: { male: 51, female: 49 },
      age: [0.17, 0.24, 0.22, 0.14, 0.13, 0.1].map((r) => {
        return Math.round(visitorFlow[2].data.report.yd_num * r)
      }),
    },
  },
}
// 经济画像
const userAssets = {
  0: {
    money: [462, 1037, 851, 472, 291],
    house: Math.round((1062 / visitorFlow[0].data.report.yd_num) * 10000) / 100,
    car: Math.round((1442 / visitorFlow[0].data.report.yd_num) * 10000) / 100,
  },
  2: {
    money: [952, 1184, 611, 364, 264],
    house: Math.round((1134 / visitorFlow[2].data.report.yd_num) * 10000) / 100,
    car: Math.round((1943 / visitorFlow[2].data.report.yd_num) * 10000) / 100,
  },
}
export {
  mall,
  professionData,
  ONLINE_HTTP,
  STATIC_URL,
  visitorFlow,
  visitorRecord,
  userProfile,
  userAssets,
}
